import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { PlayerListComponent } from './components/player-list/player-list.component';
import {
  RouterModule,
  Routes,
  ActivatedRouteSnapshot,
  ActivatedRoute
} from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { CreatePlayerComponent } from './components/create-player/create-player.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlayerComponent } from './components/player/player.component';
import { TeamComponent } from './components/team/team.component';
import { LoginComponent } from './components/login/login.component';
import {
  AuthGuardService as AuthGuard,
  AuthGuardService
} from './services/auth-gaurd/auth-garud.service';
import { MessagingService } from './services/messaging/messaging.service';
import { HttpClientModule } from '@angular/common/http';

const routes: Routes = [
  { path: '', component: PlayerListComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  {
    path: 'create-player',
    component: CreatePlayerComponent,
    canActivate: [AuthGuard]
  },
  { path: 'player/:id', component: PlayerComponent, canActivate: [AuthGuard] },
  { path: 'team/:id', component: TeamComponent, canActivate: [AuthGuard] }
];

@NgModule({
  declarations: [
    AppComponent,
    PlayerListComponent,
    CreatePlayerComponent,
    PlayerComponent,
    TeamComponent,
    LoginComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    AngularFireAuthModule,
    MaterialModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [AuthGuardService, MessagingService],
  bootstrap: [AppComponent]
})
export class AppModule {}
